<div class="w-full px-4">
  <div class="w-full flex flex-column gap-3">
    <div class="flex align-items-center justify-content-between">
      <h1 class="text-left col-6 font-bold text-4xl">Student Reports</h1>
      <div class="flex align-items-center justify-content-end gap-3">
        <p-button icon="pi pi-download" (click)="downloadStudentListExcel()" label="Download Reports"
          styleClass="sampleBtn" />
        <p-button *ngIf="isSuperAdmin" label="Sync Reports" icon="pi pi-sync" (click)="openSyncPopup()"
          styleClass="p-button-primary" [loading]="isLoadingSyncStatus">
        </p-button>
      </div>
    </div>
    <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
      <h2 class="text-left font-medium text-2xl" style="color: #303030;">Search</h2>
      <form [formGroup]="filterForm" (ngSubmit)="getMindlerReports(1)" class="w-full flex flex-wrap">
        <div class="w-full grid">
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="text-left font-normal text-base" style="color: #424242;">From Date</b>
            <p-calendar [showClear]="true" formControlName="fromDate" [iconDisplay]="'input'" [showIcon]="true"
              inputId="icondisplay" class="w-full" styleClass="cal_full" />
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="text-left font-normal text-base" style="color: #424242;">To Date</b>
            <p-calendar [showClear]="true" formControlName="toDate" [iconDisplay]="'input'" [showIcon]="true"
              inputId="icondisplay" class="w-full" styleClass="cal_full" />
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">High-School</b>
            <p-autoComplete [showClear]="true" placeholder="Name" formControlName="highSchoolName"
              [suggestions]="schoolNames"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('highSchoolName')?.value}" class="w-full"
              (completeMethod)="filterSchoolNames($event)" styleClass="fullWidth" optionValue="name" optionLabel="name">
            </p-autoComplete>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Student Name</b>
            <p-autoComplete [showClear]="true" placeholder="Name" formControlName="studentName" [suggestions]="names"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('studentName')?.value}" class="w-full"
              (completeMethod)="filterNames($event)" styleClass="fullWidth" optionValue="name" optionLabel="name">
            </p-autoComplete>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Email</b>
            <p-autoComplete [showClear]="true" placeholder="Email" formControlName="email" [suggestions]="emails"
              class="w-full" (completeMethod)="filterEmails($event)" styleClass="fullWidth" optionValue="email"
              optionLabel="email">
            </p-autoComplete>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Test Status</b>
            <p-dropdown [options]="assessmentStatusOptions" styleClass="selectFull" class="w-full" optionLabel="name"
              optionValue="value" formControlName="assessmentState" filterBy="name" [showClear]="true" appendTo="body"
              placeholder="Select Test-Status">
            </p-dropdown>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Test Type</b>
            <p-dropdown [options]="assessmentTypeOptions" styleClass="selectFull" class="w-full" optionLabel="name"
              optionValue="value" formControlName="assessmentType" [showClear]="true" appendTo="body"
              placeholder="All">
            </p-dropdown>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Academic Session</b>
            <p-dropdown [options]="sessionOptions" styleClass="selectFull" class="w-full" formControlName="academicSession"
              [showClear]="true" appendTo="body" placeholder="All academic sessions">
            </p-dropdown>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Class</b>
            <input type="text" pInputText formControlName="class" placeholder="Class" showClear="true" class="w-full"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('class')?.value}" />
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Section</b>
            <input type="text" pInputText formControlName="section" placeholder="Section" showClear="true"
              class="w-full" [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('section')?.value}" />
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <div class="w-full" style="padding-top: 27px;">
              <p-button type="submit" label="Search" class="w-full" styleClass="submitBtn" />
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="w-full">
      <p-table *ngIf="studentList && studentList.length > 0; else noRecordsFound" [value]="studentList"
        [paginator]="studentList.length!=totalRecords" [showCurrentPageReport]="true" [rows]="rowSize"
        [totalRecords]="totalRecords" [first]="first" [lazy]="true" [lazyLoadOnInit]="false" [loading]="isLoading"
        [loadingIcon]="'pi pi-spinner'" (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]"
        [showPageLinks]="true" styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Student Name</th>
            <th>Email</th>
            <th>School Name</th>
            <th>Class</th>
            <th>Section</th>
            <th>Academic Session</th>
            <th>Test Status</th>
            <th>Career/Stream Match Data</th>
            <!-- <th>Assessment Reports</th> -->
            <!-- <th>Request Report Analysis</th> -->
            <th>Assessment Reports</th>
            <th *ngIf="isSuperAdmin">Request Report Analysis</th>
            <th>Actions</th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-student>

          <tr>
            <td>{{student.studentFirstName}} {{student.studentLastName}}</td>
            <td>{{student.email}}</td>
            <td>{{student.schoolName}}</td>
            <td>{{student.class}}</td>
            <td>{{student.section}}</td>
            <td>
              <div *ngFor="let test of student.tests" class="py-1 white-space-nowrap">
                <b>{{ test.label }}:</b> {{ test.academicSession || '-' }}
              </div>
            </td>
            <td>
              <div *ngFor="let test of student.tests" class="py-1 white-space-nowrap">
                <b>{{ test.label }}:</b> {{ getTestStatusName(test.status) }}
              </div>
            </td>
            <td>
              <ng-container *ngFor="let test of student.tests">
                <div *ngIf="test.status === AssessmentStatus.Completed" class="py-1">
                  <p-button [loading]="isLoading" [label]="test.label + ' Match Data'"
                    (click)="getMatchReport(student.studentId, test.type)" styleClass="viewapplication" />
                </div>
              </ng-container>
            </td>
            <td>
              <ng-container *ngFor="let test of student.tests">
                <div *ngIf="test.status === AssessmentStatus.Completed" class="py-1">
                  <b>{{ test.label }}:</b>
                  <a [href]="test.summaryReportUrl" class="px-2" styleclass="button-like">Summary Report</a>
                  <a [href]="test.detailReportUrl" class="px-2" styleclass="button-like">Detail Report</a>
                </div>
              </ng-container>
            </td>
            <td *ngIf="isSuperAdmin">
              <ng-container *ngFor="let test of student.tests">
                <div *ngIf="test.reportAnalysis" class="py-1">
                  <b>{{ test.label }}:</b> {{ test.reportAnalysis }}
                </div>
              </ng-container>
            </td>
            <td>
              <p-button class="px-2" [loading]="isLoading" label="View Profile" icon="pi pi-user"
                styleClass="w-7rem viewapplication" (click)="viewProfile(student.studentId)" />
            </td>
          </tr>
        </ng-template>
      </p-table>
      <ng-template #noRecordsFound>
        <div class="w-full flex flex-column align-items-center py-4 gap-5">
          <div class="w-full flex align-items-center justify-content-center">
            <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
          </div>
          <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<p-dialog [header]="matchDialogHeader" [(visible)]="isVisible" [modal]="true" [style]="{ width: '70rem' }">
  <div class="w-full ">
    <div class="w-full flex flex-column gap-3">
      <div class="streams-container grid">
        <div *ngFor="let stream of matchReport?.data; trackBy: trackByStreamId"
          class="col-12 md:col-6 flex flex-column align-items-center">
          <!-- <img
              [src]="stream.image"
              width="120"
              height="120"
              alt="{{ stream.title }}"
              class="mb-2 border-round shadow-2"
              ngOptimizedImage
            /> -->
          <div class="w-full h-full flex flex-column gap-2 p-3 border-round-lg border-1 border-bluegray-100"
            style="background-color: #fff;">
            <h4 class="text-left font-medium text-xl" style="color: #000086;">{{ stream.name }}</h4>
            <div [innerHTML]="stream.description" class="w-full flex flex-column gap-2 text_des"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Sync Reports Popup -->
<p-dialog header="Sync Reports Status" [(visible)]="isSyncPopupVisible" [modal]="true" [style]="{ width: '60rem' }"
  [closable]="true">
  <div class="w-full">
    <div class="w-full flex flex-column gap-4">
      <!-- Status Summary -->
      <div class="grid">
        <div class="col-12 md:col-4">
          <div class="p-3 border-round-lg bg-blue-50 border-1 border-blue-200">
            <div class="text-center">
              <i class="pi pi-clock text-blue-500 text-2xl mb-2"></i>
              <h3 class="text-blue-700 font-bold text-xl">{{ syncStatus?.totalPendingCount || 0 }}</h3>
              <p class="text-blue-600 font-medium">Pending Students</p>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4">
          <div class="p-3 border-round-lg bg-green-50 border-1 border-green-200">
            <div class="text-center">
              <i class="pi pi-check-circle text-green-500 text-2xl mb-2"></i>
              <h3 class="text-green-700 font-bold text-xl">{{ syncStatus?.totalCompletedCount || 0 }}</h3>
              <p class="text-green-600 font-medium">Completed</p>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4">
          <div class="p-3 border-round-lg bg-red-50 border-1 border-red-200">
            <div class="text-center">
              <i class="pi pi-exclamation-triangle text-red-500 text-2xl mb-2"></i>
              <h3 class="text-red-700 font-bold text-xl">{{ syncStatus?.totalFailedCount || 0 }}</h3>
              <p class="text-red-600 font-medium">Failed</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex justify-content-center gap-3">
        <p-button label="Download Pending Data" icon="pi pi-download" (click)="downloadPendingData()"
          styleClass="p-button-secondary" [disabled]="!syncStatus?.pendingStudents?.length">
        </p-button>
        <p-button label="Sync Now" icon="pi pi-sync" (click)="startSyncProcess()" styleClass="p-button-primary"
          [loading]="isSyncing" [disabled]="!syncStatus?.pendingStudents?.length">
        </p-button>
      </div>

      <!-- Progress Bar -->
      <div *ngIf="isSyncing" class="w-full">
        <div class="flex justify-content-between mb-2">
          <span class="font-medium">Processing students...</span>
          <span class="font-medium">{{ processedCount }} / {{ totalToProcess }}</span>
        </div>
        <p-progressBar [value]="syncProgress" [showValue]="false" styleClass="h-1rem">
        </p-progressBar>
      </div>

      <!-- Pending Students Table -->
      <div *ngIf="syncStatus?.pendingStudents?.length" class="w-full">
        <h4 class="font-medium text-lg mb-3">Pending Students ({{ syncStatus?.pendingStudents?.length || 0 }})</h4>
        <p-table [value]="syncStatus?.pendingStudents || []" [paginator]="true" [rows]="5"
          [showCurrentPageReport]="true" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th>Student Name</th>
              <th>Email</th>
              <th>Assessment %</th>
              <th>Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-student>
            <tr>
              <td>{{ student.studentName }}</td>
              <td>{{ student.email }}</td>
              <td>{{ student.assessmentPercentage }}%</td>
              <td>
                <span class="p-1 px-2 border-round text-xs font-medium" [ngClass]="{
                          'bg-orange-100 text-orange-700': student.status === 'InProgress',
                          'bg-yellow-100 text-yellow-700': student.status === 'Pending'
                        }">
                  {{ student.status }}
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</p-dialog>